import React from 'react';
import { formatMessage } from '../../../../../locale';
import  CheckBox  from '../../checkbox/CheckBox';
import { Label, Input, DIV } from '../ModalContent.style';
import Description from '../Description/Description';

interface TooltipContentProps {
  titleSv: string;
  titleEn: string;
  descriptionSv: string;
  descriptionEn: string;
  isTooltip: boolean;
  setTitleSv: (value: string) => void;
  setTitleEn: (value: string) => void;
  setDescriptionSv: (value: string) => void;
  setDescriptionEn: (value: string) => void;
  setIsTooltip: (value: boolean) => void;
  selectedType?: any;
  mode?: string;
  setSelectedRisk?: (value: boolean) => void;
  userCompany?: any;
  allwaysTooltip?: boolean;
}

const TooltipContent: React.FC<TooltipContentProps> = ({
  titleSv,
  titleEn,
  descriptionSv,
  descriptionEn,
  isTooltip,
  setTitleSv,
  setTitleEn,
  setDescriptionSv,
  setDescriptionEn,
  setIsTooltip,
  selectedType,
  mode,
  setSelectedRisk,
  userCompany,
  allwaysTooltip
}) => {
  return (
    <DIV>
      <h2 style={{ textAlign: 'left' }}>
        {formatMessage({ id: 'taskType.additionalInformation', defaultMessage: 'Additional information' })}
      </h2>
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <Label style={{ marginBottom: '0.5rem', textAlign: 'left' }}>
          {formatMessage({ id: 'taskType.title', defaultMessage: 'Title' })} SV
        </Label>
        <Input
          type="text"
          value={titleSv}
          onChange={(e) => setTitleSv(e.target.value)}
          placeholder={formatMessage({ id: 'taskType.titlePlaceholder', defaultMessage: 'Enter a task type name' })}
          color={userCompany?.button_color}
          style={{ width: '100%' }}
        />
      </div>
      
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <Label style={{ marginBottom: '0.5rem', textAlign: 'left' }}>
          {formatMessage({ id: 'taskType.description', defaultMessage: 'Custom Field Name' })} SV
        </Label>
        <Description
          description={descriptionSv}
          setDescription={setDescriptionSv}
        />
      </div>

      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <Label style={{ marginBottom: '0.5rem', textAlign: 'left' }}>
          {formatMessage({ id: 'taskType.title', defaultMessage: 'Title' })} EN
        </Label>
        <Input
          type="text"
          value={titleEn}
          onChange={(e) => setTitleEn(e.target.value)}
          placeholder={formatMessage({ id: 'taskType.titlePlaceholder', defaultMessage: 'Enter a task type name' })}
          color={userCompany?.button_color}
          style={{ width: '100%' }}
        />
      </div>
      
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <Label style={{ marginBottom: '0.5rem', textAlign: 'left' }}>
          {formatMessage({ id: 'taskType.description', defaultMessage: 'Custom Field Name' })} EN
        </Label>
        <Description
          description={descriptionEn}
          setDescription={setDescriptionEn}
        />
      </div>

      {!allwaysTooltip && (<CheckBox
        isChecked={isTooltip}
        onChange={selectedType && selectedType.value === 'Risks' && mode === 'edit' ? setSelectedRisk : setIsTooltip as any}
        label={formatMessage({ id: 'taskType.tooltip', defaultMessage: 'Tooltip' })}
      />)}
    </DIV>
  );
};

export default TooltipContent;